import { ROLES } from '../../utils/constants';
import { hasPlatformPermission } from './platformAccess';

/** Backend still enforces this. The menu and route guard are not the security boundary. */
export function canManagePricing({ role, permissions } = {}) {
  return hasPlatformPermission({ role, permissions }, 'pricingManagement');
}

export function canAssignPricing(role) {
  return role === ROLES.SUPERADMIN;
}
